import { isNil } from 'ramda';

import * as constants from '@gef-ui/validations/constants';
import validationFactory from '@gef-ui/validations/factory/validationFactory';

import * as asyncValidationFunctions from './async';
import commonValidations from './common';
import * as customFunctions from './custom';

/**
 *  Run validations only if there is some input
 */
const hasValue = ({ fieldValue }) => {
	if (fieldValue === '') return false;

	return !isNil(fieldValue);
};

const customValidationsFunctions = validationFactory({ ...customFunctions });

export const createValidation = ({ functionName, args, when = hasValue, severity = constants.severity.ERROR }) => {
	if (commonValidations[functionName]) {
		return commonValidations({ functionName, args, severity, when });
	}

	return customValidationsFunctions({ functionName, args, severity, when });
};

export const createAsyncValidation = ({ functionName, args, when = hasValue, severity = constants.severity.ERROR }) => {
	return {
		validate: asyncValidationFunctions[functionName](args),
		args,
		severity,
		when,
	};
};
